import { IconProps } from '../../../common/types'

const Watch: React.FC<IconProps> = () => {
  return (
    <svg
      width="22"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="watch-icon"
    >
      <style>
        {`
          .watch-icon path {
            stroke: black;
            transition: stroke 0.3s ease-in-out;
          }
          .watch-icon:hover path {
            stroke: blue;
          }
        `}
      </style>
      <path
        d="M17.4775 15.5L15.4995 22H8.49948L6.52148 15.5M6.52148 8.5L8.49948 2H15.4995L17.4775 8.5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 12C18.5 13.2885 18.125 14.49 17.478 15.5C16.8906 16.4201 16.0807 17.1773 15.1233 17.7017C14.1658 18.226 13.0916 18.5006 12 18.5C10.9084 18.5006 9.8342 18.226 8.87674 17.7017C7.91928 17.1773 7.10942 16.4201 6.52201 15.5C5.85285 14.4554 5.4981 13.2405 5.50001 12C5.50001 10.7115 5.87501 9.51 6.52201 8.5C7.10942 7.57989 7.91928 6.82267 8.87674 6.29832C9.8342 5.77397 10.9084 5.49941 12 5.5C13.0916 5.49941 14.1658 5.77397 15.1233 6.29832C16.0807 6.82267 16.8906 7.57989 17.478 8.5C18.1472 9.54457 18.5019 10.7595 18.5 12Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 8.5V12L14 14"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Watch
